export default {
  'AI Face Animator': 'AIフェイスアニメーター',
  'Create incredible facial expressions with brainwashing music, find the magic for fun.': '洗脳されるような音楽で信じられないような顔の表情を作り、楽しみながら魔法を見つけ出しましょう。',
  'Upload a photo': '写真をアップロードする',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.': '注意：選択した写真の顔がレンズに向いていることを確認してください。そうでない場合は、正常に処理できません。',
  'Uploaded successfully!': 'アップロードは成功しました！',
  'Please select a template below': '以下のテンプレートを選択してください。',
  'Choose a GIF': 'GIFを選ぶ',
  'Use this template': 'このテンプレートを使用する',
  'Verify successfully! You will': '認証に成功しました。まもなく {{email}} より動画が届きます。',
  'You will': 'まもなく {{email}} より動画が届きます。',
  'What you should expect to happen next': '次に起こること',
  'We will process your photo into a dynamic video.': 'あなたの写真をダイナミックな動画に加工します。',
  'After processing, we will send the video to your email.': '加工後、お客様のメールに動画をお送りします。',
  'You can check the video in your email.': 'メールで動画を確認することができます。',
  'Your video will be delivered via email': '動画はメールでお届けします',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.': 'ダイナミックなビデオの合成には20～30分かかりますので、しばらくお待ちください。お客様のプライバシー保護のため、アップロードされた写真は処理終了後に自動的に削除されます。',
  'Your Email': 'あなたのEメール',
  'Last Name': '名',
  'First Name': '姓',
  'Go back': '戻る',
  'Invalid email address':'メールアドレスが無効です',
  'Enter verification code':'認証コードの入力',
  'Enter the verification code that we sent to': '私たちが{{email}}に送信した認証コードを入力してください',
  'Resend': '再送する',
  'Verification code': '検証コード',
  'Resend after': '{{num}}秒後に再送信',
  'The verification code is invalid. You can request a new one.': '認証コードが無効です。新しいコードをリクエストしてください。',
  'Synthesize Video': '動画を合成する',
  'Too many attempts, please try again later.': 'あまりにも多くの試みは、後でもう一度試してください。',
}